import React, {createContext, useContext, useEffect, useState} from 'react';
import Modal from "../components/Modal/Modal";
import ModalSuccess from "../components/Modal/ModalSuccess";
import ModalError from "../components/Modal/ModalError";
import ModalConfirm from "../components/Modal/ModalConfirm";
import ModalRating from "../components/Modal/ModalRating";
import ModalAlert from "../components/Modal/ModalAlert";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);
export const ModalProvider = ({ children }) => {
    const [modalConfig, setModalConfig] = useState({ isOpen: false, type: null, props: {}, timeoutId: null });

    useEffect(() => {
        return () => clearTimeout(modalConfig.timeoutId);
    }, [modalConfig.timeoutId]);

    const showModal = (type, props = {}) => {
        clearTimeout(modalConfig.timeoutId);

        const timeoutId = props.timeout ? setTimeout(hideModal, props.timeout) : null;
        setModalConfig({ isOpen: true, type, props, timeoutId });
    };

    const hideModal = () => {
        clearTimeout(modalConfig.timeoutId);
        setModalConfig({ isOpen: false, type: null, props: {}, timeoutId: null });
    };

    const renderModal = () => {
        const { type, props } = modalConfig;
        const commonProps = { onClose: hideModal, ...props };
        switch (type) {
            case 'classic':
                return <Modal {...commonProps} />;
            case 'success':
                return <ModalSuccess {...commonProps} />;
            case 'error':
                return <ModalError {...commonProps} />;
            case 'confirm':
                return <ModalConfirm {...commonProps} />;
            case 'rating':
                return <ModalRating {...commonProps} />;
            case 'alert':
                return <ModalAlert {...commonProps} />;
            default:
                return null;
        }
    };

    return (
        <ModalContext.Provider value={{ showModal, hideModal }}>
            {children}
            {modalConfig.isOpen && renderModal()}
        </ModalContext.Provider>
    );
};